module.exports = __webpack_public_path__ + "static/media/linkAja.f4967926.png";